import { App } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import VueAxios from 'vue-axios';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { Storage } from '@/core/helpers/Storage';
import { Actions } from '@/store/enums/StoreEnums';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const qs = require('qs');
/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
	/**
	 * @description property to share vue instance
	 */
	public static vueInstance: App;

	/**
	 * @description initialize vue axios
	 */
	public static init(app: App<Element>) {
		ApiService.vueInstance = app;
		ApiService.vueInstance.use(VueAxios, axios);
		ApiService.vueInstance.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
		ApiService.vueInstance.axios.interceptors.response.use(
		res => res,
		err => {
			
			ApiService.handleErrors(err.response);
			return Promise.reject(err);
		}
);
	}

	/**
	 * @description set the default HTTP request headers
	 */
	public static setHeader(): void {
		
		ApiService.vueInstance.axios.defaults.headers.common['Accept'] = 'application/json';
		ApiService.vueInstance.axios.defaults.headers.common['timezone'] = 'Europe/Athens';
		//ApiService.vueInstance.axios.defaults.headers.common['StoreID'] = 'application/json';
	}
	

	/**
	 * @description send the GET HTTP request
	 * @param resource: string
	 * @param params: AxiosRequestConfig
	 * @returns Promise<AxiosResponse>
	 */
	public static query(resource: string, params: AxiosRequestConfig): Promise<AxiosResponse> {
		return ApiService.vueInstance.axios.get(resource, params);
	}

	/**
	 * @description send the GET HTTP request
	 * @param resource: string
	 * @param slug: string
	 * @returns Promise<AxiosResponse>
	 */
	// public static async get(resource: string, slug = '' as string, params = {}): Promise<AxiosResponse> {
	// 	store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
	// 	const headers = ApiService.getHeadersForRequest()
		
	// 	const axiosResponse = await ApiService.vueInstance.axios.get(`${resource}/${slug}`,{
	// 		...headers,
	// 		params
	// 	});
		
	// 	// const headers = axiosResponse.response.headers;
	// 	store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");

	// 	if(axiosResponse.headers){
	// 		if(axiosResponse.headers['x-pagination']){
	// 			store.dispatch(Actions.SET_PAGINATION_PARAMS,axiosResponse.headers['x-pagination'])
	// 		}			
	// 	}
		
		
	// 	return axiosResponse
	// } 

	public static async get(resource: string, slug = '' as string, params = {},key = null) {
		store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
		const headers = ApiService.getHeadersForGetRequest()
		const axiosResponse = await ApiService.vueInstance.axios.get(`${resource}/${slug}`,{
			headers: headers,
			params:params,
			paramsSerializer: params => {
				return qs.stringify(params, { arrayFormat: 'indices', allowDots: true });
			},
			});
		
		store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
		if(axiosResponse.headers){
			if(axiosResponse.headers['x-pagination'] && key){				
				store.dispatch(Actions.SET_PAGINATION_PARAMS,{data: axiosResponse.headers['x-pagination'], key:key})
				
			}			
		}
		
		
		
		return axiosResponse
	} 
	

	/**
	 * @description set the POST HTTP request
	 * @param resource: string
	 * @param params: AxiosRequestConfig
	 * @returns Promise<AxiosResponse>
	 */
	public static async post(resource: string, params: AxiosRequestConfig, isMultipartForm = false): Promise<AxiosResponse> {
		store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
		
		const headers = ApiService.getHeadersForPostPatchDeleteRequest()
		if(isMultipartForm){
			headers['Content-Type'] = 'multipart/form-data';
		}
		try{
			const response = await ApiService.vueInstance.axios.post(`${resource}`, params, {...headers});
			return response;
		} finally {
			store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
		}
		
	}
	
	/**
	 * @description set the PATCH HTTP request
	 * @param resource: string
	 * @param params: AxiosRequestConfig
	 * @returns Promise<AxiosResponse>
	 */
	public static async patch(resource: string, params: AxiosRequestConfig, isMultipartForm = false) {
		const headers = ApiService.getHeadersForPostPatchDeleteRequest();
		
		
		if(isMultipartForm){
			headers['Content-Type'] = 'multipart/form-data';
		}
		
		const response = await ApiService.vueInstance.axios.patch(`${resource}`, params, {...headers});
		
		return response;
		
	}
	

	/**
	 * @description send the UPDATE HTTP request
	 * @param resource: string
	 * @param slug: string
	 * @param params: AxiosRequestConfig
	 * @returns Promise<AxiosResponse>
	 */
	public static update(
		resource: string,
		slug: string,
		params: AxiosRequestConfig
	): Promise<AxiosResponse> {
		const headers = ApiService.getHeadersForPostPatchDeleteRequest()
		return ApiService.vueInstance.axios.put(`${resource}`, params, {...headers});
	}

	/**
	 * @description Send the PUT HTTP request
	 * @param resource: string
	 * @param params: AxiosRequestConfig
	 * @returns Promise<AxiosResponse>
	 */
	public static put(resource: string, params: AxiosRequestConfig): Promise<AxiosResponse> {
		const headers = ApiService.getHeadersForPostPatchDeleteRequest()
		return ApiService.vueInstance.axios.put(`${resource}`, params, {...headers});
	}

	/**
	 * @description Send the DELETE HTTP request
	 * @param resource: string
	 * @returns Promise<AxiosResponse>
	 */
	public static delete(resource: string): Promise<AxiosResponse> {
		const headers = ApiService.getHeadersForPostPatchDeleteRequest()
		headers['Content-Type'] =  'application/json';
		return ApiService.vueInstance.axios.delete(resource,{...headers});
	}


	public static getHeadersForGetRequest(){
		const headers= {
				
			
		}
		if(Storage.get('apiToken')){
			headers['Authorization']  =  `Bearer `+Storage.get('apiToken');
		}
		if(Storage.get('storeID')){
			headers['StoreID']  =  Storage.get('storeID');
		}
			if(Storage.get('clientID')){
				headers['clientID']  =  Storage.get('clientID');
			}
			headers['timezone'] = 'Europe/Athens';
		return headers;
	}	
	public static getHeadersForPostPatchDeleteRequest(){
		const config= {
			headers:{

			}				
		}
		if(Storage.get('apiToken')){
			config.headers['Authorization']  =  `Bearer `+Storage.get('apiToken');
		}
		if(Storage.get('storeID')){
			config.headers['StoreID']  =  Storage.get('storeID');
		}
		if(Storage.get('clientID')){
			config.headers['clientID']  =  Storage.get('clientID');
		}
		// config.headers["Access-Control-Allow-Origin"] = "*";
		// config.headers["Access-Control-Allow-Credentials"] = "true";
		// config.headers["Access-Control-Allow-Methods"] = "GET,HEAD,OPTIONS,POST,PUT";
		// config.headers["Access-Control-Allow-Headers"] = "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers";
		
		return config;
	}	
	public static handleErrors(response){	
		store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
		store.dispatch(Actions.SET_FORM_LOADING, {flag: false});
		//this.context.commit(Mutations.SET_FORM_LOADING,false)
		if(!response){
			store.dispatch(Actions.SET_ERROR,{ Error: ["Request failed."] });
			return;
		}
		if(response.status == 401 && Storage.get('apiToken')){
			Storage.clear();
			router.push({ path: '/sign-in' })
		}
		else{
			const data = response.data;
			let payload: any = null;
			if (data && typeof data === 'object' && data.errors !== undefined) {
				payload = data.errors;
			} else if (typeof data === 'string') {
				payload = data;
			} else if (data && typeof data === 'object' && data.title) {
				payload = data.title;
			} else if (data) {
				payload = data;
			} else {
				payload = `Request failed (${response.status})`;
			}
			store.dispatch(Actions.SET_ERROR, payload);
		}


	}

}

export default ApiService;
